import type { VoidComponent } from "solid-js";
import { For, mergeProps, Show } from "solid-js";
import { Icon } from "../icon/Icon";
import Text from "../text/Text";
import { first, slice } from "lodash-es";
import { A } from "@solidjs/router";
import { useTranslation } from "../../state/i18n";

type Crumb = {
  label: string;
  href: string;
};

type BreadcrumbProps = {
  crumbs: Crumb[];
  currentLabel?: string;
};

export const Breadcrumb: VoidComponent<BreadcrumbProps> = (props) => {
  const { t } = useTranslation();

  return (
    <nav aria-label={t(($) => $.BREADCRUMB_NAV_ARIA_LABEL)}>
      <ol class="flex gap-1">
        <Show when={first(props.crumbs)}>
          {(crumb) => (
            <li>
              <CrumbLink {...crumb()} first />
            </li>
          )}
        </Show>

        <For each={slice(props.crumbs, 1)}>
          {(crumb) => (
            <li class="flex items-center gap-1">
              <CrumbDivider />
              <CrumbLink {...crumb} />
            </li>
          )}
        </For>

        <Show when={props.currentLabel}>
          {(currentLabel) => (
            <li class="flex items-center gap-1">
              <CrumbDivider />
              <div aria-current="page" class="text-base-medium text-secondary">
                <Text as="p" text={currentLabel()} truncate class="max-w-45" />
              </div>
            </li>
          )}
        </Show>
      </ol>
    </nav>
  );
};

const CrumbDivider = () => (
  <span class="text-base-medium text-secondary" aria-hidden={true}>
    /
  </span>
);

const CrumbLink: VoidComponent<Crumb & { first?: boolean }> = (props) => {
  const merged = mergeProps({ first: false }, props);
  return (
    <A
      href={merged.href}
      class="flex cursor-pointer items-center gap-1 text-base-medium text-button-text-tertiary-default hover:text-button-text-tertiary-default-hover focus-visible:outline-default active:text-button-text-tertiary-default-pressed"
    >
      <Show when={merged.first}>
        <Icon name="chevronLeft" type="solid" size="md" class="icon-button-icon-tertiary-default" />
      </Show>
      <Text text={merged.label} truncate class="max-w-45" />
    </A>
  );
};
